import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Img } from 'src/app/core/models/DigitalKit';
import $ from 'jquery';
import 'bootstrap';

interface Card {
  title: string;
  text: string;
}

@Component({
    selector: 'app-consulting-proyect',
    templateUrl: './consulting-proyect.component.html',
    styleUrls: ['./consulting-proyect.component.css'],
    standalone: false
})
export class ConsultingProyectComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Proyecto de Consultoría');
    
    (<any>$('.carousel')).carousel();
  }

  cards: Card[] = [
    {
      title: 'RETO',
      text: 'Estudio de mercado de los proveedores tecnológicos que ofrecen Gestores de Campañas de Marketing, así como un asesoramiento y gestión integral del proyecto planteado.'
    },
    {
      title: 'OBJETIVO',
      text: 'Asesoramiento en la captación de datos valiosos de marketing para su conversión en conocimiento útil y aportación de valor a toda la cadena de conversión del lead.'
    },
    {
      title: 'SOLUCIÓN',
      text: 'Una solución que garantice la optimización de recursos a la hora de elaborar y ejecutar campañas de marketing y permita conocer la trazabilidad completa del paciente.'
    }
  ]

carousels: Img[] = [
  {
    src: 'assets/img/salesforce.png',
    alt: 'Saleforce'
  },
  {
    src: 'assets/img/sap.png',
    alt: 'SAP'
  },
  {
    src: 'assets/img/selligent.png',
    alt: 'Selligent'
  },
  {
    src: 'assets/img/zoho.png',
    alt: 'ZOHO'
  },
  {
    src: 'assets/img/eid.png',
    alt: 'Electronic ID'
  },
  {
    src: 'assets/img/sas.png',
    alt: 'SAS'
  },
  {
    src: 'assets/img/hubspot.webp',
    alt: 'Hubspot'
  },
  {
    src: 'assets/img/aws.png',
    alt: 'Amazon Web Services'
  },
  {
    src: 'assets/img/oracle.png',
    alt: 'Oracle'
  },
  {
    src: 'assets/img/microsoft.png',
    alt: 'Microsoft'
  },
  {
    src: 'assets/img/linkmobility-spain.png',
    alt: 'Link Mobility'
  }
];




}
